import { createRoot } from "react-dom/client";
import { DashboardApp } from "./DashboardApp.js";
import "./styles.css";

createRoot(document.getElementById("root")!).render(<DashboardApp />);
